import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Anonymous account creation form was presented to the user',
  name: 'viewed_anonymous_account_creation_form',
  params: [
    {
      description: 'Location of the event',
      name: 'location',
      required: true,
      type: 'enum',
      values: [
        'clip-share-link',
        'board-share-link',
        'collection-share-link',
        'content-collection',
        'custom-field-change',
        'comment-addition',
      ],
    },
    {
      description: 'Id of an object that share link is generated for',
      name: 'object_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Type of an object that share link is generated for',
      name: 'object_type',
      required: true,
      type: 'enum',
      values: ['board', 'clip', 'collection', 'canvas', 'asset'],
    },
    {
      description: 'Generated share url',
      name: 'share_url',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
